import React from "react";
import styles from "./LoadingComponent.module.scss";

export function LoadingComponent({ size = 5, center, style, className }) {
    return (
        <div
            className={className}
            style={
                center
                    ? {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          ...style,
                      }
                    : { ...style }
            }
        >
            <div
                style={{
                    display: "flex",
                    width: size * 6,
                    height: size * 6,
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div style={{ fontSize: size }} className={styles["loader"]}>
                    loading
                </div>
            </div>
        </div>
    );
}
